import { LITMUS_URL, LitmusExperimentResponse } from '@cp/constants/Global';
import axiosInstance, { logError } from '@cp/utils/ApiHelper';
import { GenericObject } from '@cp/src/types/CommonConstans';

const fetchExperimentResult = async (
  experimentName: string,
  stickynessConfig: GenericObject
): Promise<LitmusExperimentResponse> => {
  const litmusApi = `${LITMUS_URL}?name=${experimentName}`;
  return await axiosInstance
    .get(litmusApi, {
      headers: {
        'X-Target': 'LITMUS',
        ...stickynessConfig
      }
    })
    .then(response => {
      if (response.data) {
        return response.data;
      }
    })
    .catch(error => {
      logError(error);
    });
};

export default fetchExperimentResult;
